import React, {useEffect, useRef, useState} from "react";
import _axios from "../../../httpService";
import Loader from "../../Loader";
import TreeChartView from "./TreeChart/TreeChartView";
import {toast} from "react-toastify";
import tableCalc from "../../../utils/tableCalc";
import {useLocation, useNavigate} from "react-router-dom";
import './ViewDocuments.scss';
import {ArrowLeftSquareFill, ArrowRightSquareFill} from "../../../Assets/svg";
import useTitle from "../../Hooks/useTitle";
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import {addSeparatorToData} from "./ViewDocumentsFunctions";
import DynaInput from "../../UI/DynaInput/DynaInput";
import numericFunction from "../../../utils/NumericFunction";
import ModalAddGroup from "./ModalAddGroup/ModalAddGroup";

const ViewDocuments = () => {
  useTitle("چارت حسابداری");
  const tabulatorRef = useRef();
  const myLocation = useLocation();
  const navigateTo = useNavigate();
  const prefixUrl = localStorage.getItem("apiUrl");
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingTable, setIsLoadingTable] = useState(false);
  const [mainData, setMainData] = useState({
    documentDetails: {
      bedSum: undefined,
      besSum: undefined,
      column: [],
      data: [],
    },
    documentTreeChart: [],
    // i need last treechart Data cz i wanna request to show more data im table
    lastTreeChartData: {}, // object that hold last treeChartData toSend BackEnd
    tableViewType: "", // overall   full // indicate that wich view type is in table is userClicked to DetailsView?
  });
  const [sideOpenMenu, setSideOpenMenu] = useState({
    isMenuOpen: true,
    menuWidth: 330,
  });
  const [reload, setReload] = objectDataHolder(1)
  const checkBoxRef = useRef(null);

  useEffect(() => {
    // _axios.get(`${localStorage.getItem("apiUrl2")}w/dm/`).then((response) => {
    //   setSideInfo(response.data.treeChart);
    // });

    _axios
      .get(prefixUrl + "/accountingTreeChart/?request=treeChart")
      .then((res) => {
        const data = res.data;

        const temp = {...mainData};
        temp.documentTreeChart = data.treeChart;
        // tableCalc.addSeparator(columnsConfig, data.priceFields);

        setMainData(temp);

        setIsLoading(false);
      });
  }, [reload]);
  useEffect(() => {
    mainData?.documentDetails?.column?.unshift({
      formatter: "rownum",
      hozAlign: "center",
      width: 40,
    });
  }, [tabulatorRef?.current?.table]);
  const [sendMoeinData, setSendMoeinData] = useState({
    parentId: "",
    coding: "",
    name: "",
    groups: [],
    type: "permanent",
    bedOrBes: "bed",
    mode: "",
    costAndProfit: 0,
    costAndProfitType: 1
  })
  const [groupTFData, setGroupTFData] = useState([])
  const [isLoadMoein, setIsLoadMoein] = useState(false)
  const [renderTable, setRenderTable] = useState(0)
  const [openGroupBox, setOpenGroupBox] = useState(false)
  const [showModalAddGroup, setShowModalAddGroup] = useState(false)
  const [checkSZ, setCheckSZ] = useState(false)

  if (mainData.tableViewType === "long") {
    requestDataToShowDocumentDetails(mainData.lastTreeChartData, "overall");
  }

  useEffect(() => {

    setOpenGroupBox(false)
    _axios.get(prefixUrl + "/accountingGroups/?request=accountGroups")
      .then((res) => {
        if (res.data.status) {
          setOpenGroupBox(true)
          let temp = [...res.data.data]
          temp.forEach((v) => {
            let i = 0
            while (sendMoeinData.groups.length > i) {
              if (+v.groupId === sendMoeinData.groups[i]) {
                v.isCheck = "1"
                break;
              } else {
                v.isCheck = "0"
              }
              i = i + 1
            }
          })
          setGroupTFData(temp)

        } else {
          toast.error("مشکلی در دریافت داده رخ داد.");
        }
      })
  }, [renderTable])
  const requestDataToShowMoein = (inputData) => {
    setIsLoadMoein(true)
    _axios.get(prefixUrl + "/accountingAccounts/?request=newSubsidiaryAccountCode&treechartId=" + inputData.treechartId)
      .then((res) => {
        console.log(res)
        if (res.data.status) {
          sendMoeinData.parentId = inputData.treechartId
          sendMoeinData.coding = res.data.newCode
          sendMoeinData.name = ""
          sendMoeinData.groups = []
          sendMoeinData.type = "permanent"
          sendMoeinData.mode = "ADD"
          sendMoeinData.bedOrBes = "bed"
          setMainData.costAndProfit = 0
          sendMoeinData.costAndProfitType = 4
          setSendMoeinData({...sendMoeinData})
          setIsLoadMoein(false)
          setOpenGroupBox(false)
          setRenderTable(renderTable + 1)
        } else {
          toast.error("مشکلی در دریافت داده رخ داد.");
          setIsLoadMoein(false)
        }
      })
  }

  const requestDataToEditeMoein = (inputData) => {
    setIsLoadMoein(true)
    _axios.get(prefixUrl + "/accountingAccounts/?request=subsidiaryAccountData&treechartId=" + inputData.treechartId)
      .then((res) => {
        if (res.data.status) {
          debugger
          setSendMoeinData({
            parentId: res.data.data.parentId,
            coding: res.data.data.coding,
            name: res.data.data.name,
            groups: res.data.data.groupId,
            type: res.data.data.type,
            treechartId: inputData.treechartId,
            mode: "EDIT",
            bedOrBes: res.data.data.bedOrBes,
            costAndProfit: +res.data.data.costAndProfit,
            costAndProfitType: +res.data.data.costAndProfitType
          })
          setIsLoadMoein(false)
          setRenderTable(renderTable + 1)
        } else {
          toast.error("مشکلی در دریافت داده رخ داد.");
          setIsLoadMoein(false)
        }
      })
  }

  function requestDataToShowDocumentDetails(inputData, mode = "overall") {
    //debugger
    let inputDataTemp = {...inputData};
    if (inputDataTemp.subAccounts) delete inputDataTemp.subAccounts;

    const mainDataTemp = {...mainData};
    // if mode is overall so tableviewType  will change to overall  otherwise  full
    mainDataTemp.tableViewType = mode;

    // if user change the chart so change mainDataTemp.lastTreeChartData
    // i am set  lastTreeChartData to inputDataTemp to request more Data
    if (
      JSON.stringify(mainDataTemp.lastTreeChartData) !==
      JSON.stringify(inputDataTemp)
    )
      mainDataTemp.lastTreeChartData = inputDataTemp;
    setIsLoadingTable(true);

    _axios
      .get(
        prefixUrl +
        "/accountingTreeChart/?request=accountDocuments&detail=" +
        JSON.stringify(inputDataTemp) +
        "&mod=" +
        mode
      )
      .then((res) => {
        const data = res.data;
        if (data.status) {
          makeDescriptionWider(data.accountDocuments.column);
          data.accountDocuments?.hasEdit &&
          tableCalc.AddEditButtonToLastColumns(
            data.accountDocuments.column,
            "ویرایش",
            () =>
              '<i class="fa fa-edit"></i>',
            99,
            (e, row) => {
              const {
                destination,
                id,
              } = row.getData();
              const backUrl = myLocation.pathname;
              navigateTo(destination, {
                state: {
                  id: id,
                  primaryKey: id,
                  from: {url: backUrl, data: {}},
                  manualDocumentId: id,
                },
              });
            }
          );

          data.accountDocuments?.sumFields &&
          tableCalc.addSeparatorAndAddBottomCalc(
            data.accountDocuments.column,
            data.accountDocuments.sumFields
          );
          mainDataTemp.documentDetails = data.accountDocuments;
          tableCalc.addSeparator(
            mainDataTemp.documentDetails.column,
            data.accountDocuments.priceFields
          );
          tableCalc.addSeparatorToSingleColumn(
            mainDataTemp.documentDetails.column,
            ["remaining"]
          );
          // main Data is the Object that i need to  set Again So I have to set it here to fix PDF
          mainDataTemp.documentDetails.data = addSeparatorToData(
            mainDataTemp.documentDetails.data,
            ["bed", "bes", "remaining"]
          );
          // if mode is full please close the treechart  otherwise open treechart
          mode === "full"
            ? openTreeChartViewHandler()
            : closeTreeChartViewHandler();
          setMainData(mainDataTemp);
          setIsLoadingTable(false);
          // toast.success("اطلاعات دریافت شد.")
        } else {
          toast.error("مشکلی در دریافت داده رخ داد.");
        }
      });
  }

  const [enterText, setEnterText] = useState("");

  function openTreeChartViewHandler() {
    {
      setSideOpenMenu((ps) => {
        const temp = {...ps};
        temp.menuWidth = 0;
        return temp;
      });

      setTimeout(() => {
        setSideOpenMenu((ps) => {
          const temp = {...ps};
          temp.isMenuOpen = false;
          return temp;
        });
      }, 100);
    }
  }

  function closeTreeChartViewHandler() {
    setSideOpenMenu({
      isMenuOpen: true,
      menuWidth: 330,
    });
  }

  function makeDescriptionWider(column) {
    column.forEach((v) => {
      //debugger
      if (v.field === "description") {
        v.minWidth = 420;
      }
    });
  }

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setSendMoeinData({
      ...sendMoeinData,
      [name]: numericFunction.p2e(value),
    });
  }

  const checkboxHandler = (e, v) => {
    if (e.target.checked) {
      let temp = [...sendMoeinData.groups]
      temp.push(+e.target.value)
      setSendMoeinData({...sendMoeinData, groups: temp})
      v.isCheck = "1"
    } else {
      checkBoxRef.current.checked = false
      const filtered = sendMoeinData.groups.filter((v) => +v !== +e.target.value)
      setSendMoeinData({...sendMoeinData, groups: filtered})
      v.isCheck = "0"
    }
  }

  const checkboxHandlerSelectAll = (e) => {

    if (e.target.checked) {
      let temp = [...groupTFData]
      let tempTwo = []
      temp.forEach((v) => {
        tempTwo.push(v.groupId)
        v.isCheck = "1"
      })
      setGroupTFData(temp)
      setSendMoeinData({...sendMoeinData, groups: tempTwo})

    } else {
      let temp = [...groupTFData]
      temp.forEach((v) => {
        v.isCheck = "0"
      })
      setGroupTFData(temp)
      setSendMoeinData({...sendMoeinData, groups: []})
    }
  }

  const moeinFormHandler = () => {
    if (sendMoeinData.mode === "ADD") {
      _axios.post(prefixUrl + "/accountingAccounts/", {request: "newSubsidiaryAccount", data: sendMoeinData})
        .then((res) => {
          if (res.data.status) {
            toast.success(res.data.message)
            setSendMoeinData({
              parentId: "",
              coding: "",
              name: "",
              groups: [],
              type: "permanent",
              bedOrBes: "bed",
            })
            setReload(reload + 1)
          } else {
            toast.error(res.data.message);
          }
        })
    }

    if (sendMoeinData.mode === "EDIT") {
      _axios.put(prefixUrl + "/accountingAccounts/", {request: "editSubsidiaryAccount", data: sendMoeinData})
        .then((res) => {
          if (res.data.status) {
            toast.success(res.data.message)
            setSendMoeinData({
              parentId: "",
              coding: "",
              name: "",
              groups: [],
              type: "permanent",
              bedOrBes: "bed",
            })
            setReload(reload + 1)
          } else {
            toast.error(res.data.message);
          }
        })
    }

  }

  return (
    <>
      <div className="breadCrumb" style={{fontSize: "12px"}}>
        {enterText}
      </div>
      <div
        className={"py-2 px-4 justToRemoveMarginInTableInThisPage"}
        style={{
          width: "100%",
          margin: "0 auto",
          height: "95vh",
          overflow: "scroll",
          fontSize: 13,
        }}>
        <div className={"mb-1"}>
          {/* <Header
          title={
            componentData.title
              ? "چارت حسابداری / " + componentData.title
              : "چارت حسابداری"
          }
        /> */}
        </div>

        {isLoading ? (
          <Loader/>
        ) : (
          <div className={"d-flex"}>
            <div className={"position-relative"}>
              <div
                style={{
                  transition: "all 0.8s",
                  background: 'white',
                  width: sideOpenMenu.menuWidth,
                  height: "85vh",
                  overflow: "visible",
                  borderRadius: 10,
                  padding: sideOpenMenu.isMenuOpen ? 20 : 0,
                  overflowY: "scroll",
                  position: "relative",
                }}
              >
                {sideOpenMenu.isMenuOpen && (
                  <TreeChartView
                    treeChartData={mainData.documentTreeChart}
                    requestDataToShowDocumentDetails={
                      requestDataToShowDocumentDetails
                    }
                    requestDataToShowMoein={requestDataToShowMoein}
                    requestDataToEditeMoein={requestDataToEditeMoein}
                    onClickJoinTitle={(enter) => setEnterText(enter)}
                    setReload={setReload}
                  />
                )}
              </div>
            </div>
            <div
              style={{
                width: "100%",
                borderRadius: 10,
                overflow: "scroll",
                marginRight: '20px'
              }}
              className={""}
            >
              <div className={"position-relative"}>
                <div
                  className={"position-fixed"}
                  style={{
                    // transform: 'translateY(-20px)'
                    transform: "translate(20px,-10px)",
                  }}
                >
                  {sideOpenMenu.isMenuOpen ? (
                    <div onClick={openTreeChartViewHandler}>
                      <ArrowRightSquareFill/>
                    </div>
                  ) : (
                    <div onClick={closeTreeChartViewHandler}>
                      <ArrowLeftSquareFill/>
                    </div>
                  )}
                </div>
                {mainData.documentDetails.column.length === 0 ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "60vh",
                    }}
                  >
                    داده ای جهت نمایش وجود ندارد.
                  </div>
                ) : (
                  <>
                    {isLoadingTable ? (
                      <Loader/>
                    ) : (
                      <div className="main-moein-view-documents">

                        {!isLoadMoein ?
                          sendMoeinData.parentId !== "" &&
                          <>
                            <div className="form-moein">
                              <DynaInput typeMode={'input'}
                                         name="coding"
                                         id="codingId"
                                         label="کد"
                                         type="text"
                                         placeholder="کد موردنظر خود را وارد کنید"
                                         className={`ravan-hesab-type`}
                                         value={numericFunction.e2p(sendMoeinData.coding)}
                                         onChange={handleInputChange}/>

                              <DynaInput typeMode={'input'}
                                         name="name"
                                         id="nameId"
                                         label="عنوان"
                                         type="text"
                                         value={numericFunction.e2p(sendMoeinData.name)}
                                         placeholder="عنوان موردنظر خود را وارد کنید"
                                         className={`ravan-hesab-type`}
                                         onChange={handleInputChange}/>

                              <DynaInput typeMode={'select'}
                                         name="type"
                                         id="typeId"
                                         label="نوع"
                                         value={sendMoeinData.type}
                                         placeholder="نوع را مشخص کنید"
                                         className={`ravan-hesab-type`}
                                         selectOption={[
                                           {label: "دائم", value: "permanent"},
                                           {label: "موقت", value: "cov"}]}
                                         onChange={handleInputChange}/>

                              <DynaInput typeMode={'select'}
                                         name="bedOrBes"
                                         id="bedOrBesId"
                                         label="ماهیت"
                                         placeholder="اولویت پرونده را مشخص کنید"
                                         className={`ravan-hesab-type`}
                                         disabled={sendMoeinData.mode === "EDIT"}
                                         value={sendMoeinData.bedOrBes}
                                         selectOption={[
                                           {label: "بدهکار", value: "bed"},
                                           {label: "بستانکار", value: "bes"}]}
                                         onChange={handleInputChange}/>

                            </div>

                            <div className="float-data-side">

                              <div className="checkbox-side">
                                <input type="checkbox" id="ChBox" checked={sendMoeinData.costAndProfit === 1}
                                       onChange={(e) => {
                                         const flag = e.target.checked ? 1 : 0
                                         sendMoeinData.costAndProfit = flag
                                         if (flag === 0) {
                                           sendMoeinData.costAndProfitType = 4
                                         }else {
                                           sendMoeinData.costAndProfitType = 1
                                         }
                                         setSendMoeinData({...sendMoeinData})
                                       }
                                       }/>
                                <label htmlFor="ChBox">گزارش سود و زیان</label>
                              </div>
                              {sendMoeinData.costAndProfit === 1 &&
                                <div className="radio-side">

                                  <div className="box-radio">
                                    <input type="radio" id="R1" name="Rd1"
                                           checked={sendMoeinData.costAndProfitType === 1}
                                           onChange={() => setSendMoeinData({...sendMoeinData, costAndProfitType: 1})}/>
                                    <label htmlFor="R1">درآمد ها</label>
                                  </div>

                                  <div className="box-radio">
                                    <input type="radio" id="R2" name="Rd1"
                                           checked={sendMoeinData.costAndProfitType === 2}
                                           onChange={() => setSendMoeinData({...sendMoeinData, costAndProfitType: 2})}/>
                                    <label htmlFor="R2">هزینه های مستقیم</label>
                                  </div>

                                  <div className="box-radio">
                                    <input type="radio" id="R3" name="Rd1"
                                           checked={sendMoeinData.costAndProfitType === 3}
                                           onChange={() => setSendMoeinData({...sendMoeinData, costAndProfitType: 3})}/>
                                    <label htmlFor="R3">هزینه های سربار</label>
                                  </div>
                                  <div className="box-radio">
                                    <input type="radio" id="R4" name="Rd1"
                                           checked={sendMoeinData.costAndProfitType === 4}
                                           onChange={() => setSendMoeinData({...sendMoeinData, costAndProfitType: 4})}/>
                                    <label htmlFor="R4">موجودی کالا</label>
                                  </div>
                                </div>
                              }
                            </div>

                            <div className="table-moein">
                              <label>گروه تفصیلی ها</label>

                              <div className={`tf-group ${openGroupBox ? "tf-group-open" : ""}`}>
                                <p onClick={() => setOpenGroupBox(true)}
                                   className={`p-top-box ${openGroupBox ? "display-none-open" : ""}`}>گروه تفصیلی ها را
                                  مشخص
                                  کنید</p>
                                {groupTFData.length > 0 &&
                                  <ul>
                                    <li>
                                      <input type="checkbox" id={"CH"} value={""} ref={checkBoxRef}
                                             onChange={(e) => checkboxHandlerSelectAll(e)}/>
                                      <label htmlFor={"CH"}>همه</label>
                                    </li>
                                    {groupTFData.map((v, index) =>
                                      <li key={"G" + index}>
                                        <input type="checkbox" id={"CH" + index}
                                               checked={v.isCheck !== "0"} value={v.groupId}
                                               onChange={(e) => checkboxHandler(e, v)}/>
                                        <label htmlFor={"CH" + index}>{v.groupName}</label>
                                      </li>
                                    )}
                                  </ul>}

                                <div className={`arrow-box ${openGroupBox ? "arrow-box-open" : ""}`}
                                     onClick={() => openGroupBox === true ? setOpenGroupBox(false) : setOpenGroupBox(true)}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                       fill="none">
                                    <path
                                      d="M9.41592 12.6002C8.91527 12.6002 8.41462 12.3977 8.03555 12.0002L3.37236 7.11022C3.16494 6.89272 3.16494 6.53272 3.37236 6.31522C3.57977 6.09772 3.92307 6.09772 4.13049 6.31522L8.79368 11.2052C9.13699 11.5652 9.69486 11.5652 10.0382 11.2052L14.7014 6.31522C14.9088 6.09772 15.2521 6.09772 15.4595 6.31522C15.6669 6.53272 15.6669 6.89272 15.4595 7.11022L10.7963 12.0002C10.4172 12.3977 9.91657 12.6002 9.41592 12.6002Z"
                                      fill="#B9B9B9"/>
                                  </svg>
                                </div>
                                {showModalAddGroup &&
                                  <ModalAddGroup renderTable={renderTable}
                                                 setRenderTable={setRenderTable}
                                                 setOpenGroupBox={setOpenGroupBox}
                                                 onClose={() => setShowModalAddGroup(false)}/>}
                                <button onClick={() => setShowModalAddGroup(true)}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                       fill="none">
                                    <path
                                      d="M12 23.25C6.07 23.25 1.25 18.43 1.25 12.5C1.25 6.57 6.07 1.75 12 1.75C17.93 1.75 22.75 6.57 22.75 12.5C22.75 18.43 17.93 23.25 12 23.25ZM12 3.25C6.9 3.25 2.75 7.4 2.75 12.5C2.75 17.6 6.9 21.75 12 21.75C17.1 21.75 21.25 17.6 21.25 12.5C21.25 7.4 17.1 3.25 12 3.25Z"
                                      fill="#5D70B5"/>
                                    <path
                                      d="M16 13.25H8C7.59 13.25 7.25 12.91 7.25 12.5C7.25 12.09 7.59 11.75 8 11.75H16C16.41 11.75 16.75 12.09 16.75 12.5C16.75 12.91 16.41 13.25 16 13.25Z"
                                      fill="#5D70B5"/>
                                    <path
                                      d="M12 17.25C11.59 17.25 11.25 16.91 11.25 16.5V8.5C11.25 8.09 11.59 7.75 12 7.75C12.41 7.75 12.75 8.09 12.75 8.5V16.5C12.75 16.91 12.41 17.25 12 17.25Z"
                                      fill="#5D70B5"/>
                                  </svg>
                                </button>
                              </div>
                            </div>
                            <div className="button-moein">
                              <button onClick={moeinFormHandler}>ثبت</button>
                            </div>
                          </> : <Loader/>
                        }
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewDocuments;
